'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _units = require('../const/units');

var _transformer = require('./transformer');

var _transformer2 = _interopRequireDefault(_transformer);

var _predicate = require('../utils/predicate');

var _converters = require('../utils/converters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unitlessNumberToRemsTransformer = (0, _transformer2.default)(_predicate.isValidNonZeroNumber, function (value, data) {
  return (0, _converters.unitlessNumberToDistance)(_units.LENGTH_UNITS.EM, data.baseFontSize)(value);
});
exports.default = unitlessNumberToRemsTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/unitlessNumberToEmsTransformer.js
// module id = 677
// module chunks = 168707334958949